(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sketchus-cart-discount"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('sk-cart-discount')) return;
  const sameCode = (a,b) => String(a).trim().toLocaleUpperCase('en-US') === String(b).trim().toLocaleUpperCase('en-US');
  const codesFrom = view => [...view.querySelectorAll('[data-code]')].map(button => button.dataset.code);
  const sameCodes = (a,b) => a.length === b.length && a.every(code => b.some(other => sameCode(code,other)));
  async function changeDiscount({read,write}, code, remove) {
    const before = codesFrom(await read());
    const target = remove ? before.filter(value => !sameCode(value,code)) : [code];
    const result = codesFrom(await write(target.join(',')));
    if (remove) {
      if (!sameCodes(result,target)) throw new Error('remove_unconfirmed');
      return 'removed';
    }
    if (result.some(value => sameCode(value,code))) return 'applied';
    const restored = codesFrom(await write(before.join(',')));
    if (!sameCodes(restored,before)) throw new Error('restore_unconfirmed');
    return 'invalid';
  }
  customElements.define('sk-cart-discount',class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.strings = JSON.parse(this.querySelector('[data-coupon-strings]').textContent);
      this.input = this.querySelector('input');
      this.message = this.querySelector('[role="status"]');
      this.querySelector('form').addEventListener('submit',event => { event.preventDefault(); this.change(this.input.value.trim(),false); });
      this.addEventListener('click',event => { const button = event.target.closest('[data-code]'); if (button && this.contains(button)) this.change(button.dataset.code,true); });
      try {
        const feedback = JSON.parse(sessionStorage.getItem('sk-cart-discount-feedback') || 'null');
        sessionStorage.removeItem('sk-cart-discount-feedback');
        if (feedback && Date.now() - feedback.time < 60000 && this.strings[feedback.key]) {
          this.show(feedback.key);
          if (feedback.code) this.input.value = feedback.code;
          if (feedback.key === 'removed' || feedback.key === 'invalid') this.input.focus({preventScroll:true});
        }
      } catch (_) {}
    }
    show(key) {
      this.message.textContent = this.strings[key] || this.strings.error;
      this.message.dataset.error = String(['invalid','error','one_code'].includes(key));
    }
    async change(code,remove) {
      if (this.busy || !code) return;
      if (!remove && code.includes(',')) { this.show('one_code'); return; }
      if (document.querySelector('#SketchusNativeUpsell [aria-busy="true"],#main-cart-items.cart__items--disabled')) { this.show('wait'); return; }
      this.busy = true;
      this.setAttribute('aria-busy','true');
      this.show(remove ? 'removing' : 'checking');
      const controls = [...this.querySelectorAll('button,input'),...document.querySelectorAll('#checkout')].map(node => ({node,disabled:node.disabled}));
      const regions = [...document.querySelectorAll('#main-cart-items,#SketchusNativeUpsell,.cart__dynamic-checkout-buttons')].map(node => ({node,inert:node.inert}));
      controls.forEach(({node}) => { node.disabled = true; });
      regions.forEach(({node}) => { node.inert = true; });
      let attempted = false;
      const request = async (url,options = {}) => {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(),15000);
        try {
          const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:controller.signal});
          if (!response.ok) throw new Error('discount_request_failed');
          return await response.json();
        } finally { clearTimeout(timeout); }
      };
      const viewFrom = html => {
        if (typeof html !== 'string') throw new Error('discount_section_missing');
        const view = new DOMParser().parseFromString(html,'text/html').querySelector('sk-cart-discount');
        if (!view) throw new Error('discount_view_missing');
        return view;
      };
      const read = async () => {
        const url = new URL(this.dataset.cartUrl,location.origin);
        url.searchParams.set('sections',this.dataset.sectionId);
        const sections = await request(url);
        return viewFrom(sections[this.dataset.sectionId]);
      };
      const write = async discount => {
        attempted = true;
        const result = await request(this.dataset.updateUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount,sections:[this.dataset.sectionId],sections_url:this.dataset.cartUrl})});
        if (result.status) throw new Error('discount_rejected');
        return result.sections?.[this.dataset.sectionId] ? viewFrom(result.sections[this.dataset.sectionId]) : read();
      };
      const refresh = key => {
        try { sessionStorage.setItem('sk-cart-discount-feedback',JSON.stringify({key,code:key === 'invalid' ? code : '',time:Date.now()})); } catch (_) {}
        location.reload();
      };
      try {
        const result = await changeDiscount({read,write},code,remove);
        this.show(result);
        refresh(result);
      } catch (_) {
        this.show('error');
        if (attempted) refresh('error');
      } finally {
        this.busy = false;
        this.setAttribute('aria-busy','false');
        controls.forEach(({node,disabled}) => { node.disabled = disabled; });
        regions.forEach(({node,inert}) => { node.inert = inert; });
      }
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sketchus-native-upsell-script"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const same = (a, b) => String(a) === String(b);
  const has = (list, value) => Array.isArray(list) && list.some(id => same(id, value));
  const validSize = value => ['A4', 'A3', 'A2'].includes(value);
  const sourceEligible = (source, config) => Boolean(source && source.product_id && !source.gift_card && !has(config.excluded, source.product_id) && !config.rules.some(rule => same(rule.productId, source.product_id)));
  function previewIncluded(cart, config) {
    const previews = config.rules.filter(rule => rule.kind === 'preview').map(rule => rule.productId);
    const paidPreview = cart.items.filter(item => has(previews,item.product_id)).reduce((sum,item) => sum + (item.line_price || 0),0);
    return cart.items.some(item => sourceEligible(item,config)) && (config.previewThreshold && cart.currency === 'EUR' && cart.total_price - paidPreview >= 20000 || cart.items.some(item => has(config.previewIncludedProducts,item.product_id)));
  }
  function evaluate(source, cart, config, placement) {
    if (!config.enabled || !sourceEligible(source, config) || !cart || !Array.isArray(cart.items) || !cart.items.some(item => item.key === source.key && same(item.id, source.id))) return [];
    const keys = new Set();
    const duplicateKeys = new Set();
    config.rules.forEach(rule => { if (keys.has(rule.key)) duplicateKeys.add(rule.key); keys.add(rule.key); });
    return config.rules.map((rule, order) => {
      if (!rule.enabled || !rule.key || duplicateKeys.has(rule.key) || !rule.productId || !['frame','express','preview','generic'].includes(rule.kind)) return null;
      if (!['both',placement].includes(rule.placement) || has(rule.excluded, source.product_id)) return null;
      if (!['all','selected'].includes(rule.scope) || rule.scope === 'selected' && !has(rule.allowed, source.product_id)) return null;
      const countries = (rule.countries || []).map(value => value.trim()).filter(Boolean);
      if (countries.length && !countries.includes(config.country)) return null;
      if ((rule.minSubtotal || rule.maxSubtotal) && cart.currency !== rule.currency) return null;
      if (rule.minSubtotal && cart.total_price < rule.minSubtotal || rule.maxSubtotal && cart.total_price > rule.maxSubtotal) return null;
      if (rule.minQuantity && source.quantity < rule.minQuantity || rule.maxQuantity && source.quantity > rule.maxQuantity) return null;
      if (!['none','source_size','A4','A3','A2'].includes(rule.profile)) return null;
      if (rule.profile !== 'none' && !validSize(source.size)) return null;
      if (validSize(rule.profile) && source.size !== rule.profile) return null;
      if (rule.kind === 'frame' && !validSize(source.size)) return null;
      const included = rule.kind === 'preview' && previewIncluded(cart,config);
      let variants = (rule.variants || []).filter(variant => variant.available && Number.isFinite(variant.price) && variant.price >= 0);
      if (rule.kind === 'frame') variants = variants.filter(variant => variant.size === source.size && validSize(variant.size));
      if (!variants.length) return null;
      const existing = cart.items.filter(item => same(item.product_id, rule.productId) && (rule.kind !== 'frame' || rule.variants.some(variant => variant.size === source.size && same(variant.id, item.id))));
      if (existing.length && rule.existing === 'hide' && !included) return null;
      if (!['hide','show_added','allow_quantity'].includes(rule.existing)) return null;
      return { rule, variants, existing, included, locked: included || existing.length > 0 && !(rule.kind === 'generic' && rule.existing === 'allow_quantity'), order };
    }).filter(Boolean).sort((a,b) => a.rule.priority - b.rule.priority || a.order - b.order).slice(0, Math.min(3, Math.max(1, config.max || 3)));
  }
  const propertyKey = properties => JSON.stringify(Object.entries(properties || {}).sort(([a],[b]) => a.localeCompare(b)));
  function matchingLine(items, original) {
    const matches = items.filter(item => same(item.id,original.id) && same(item.product_id,original.product_id) && propertyKey(item.properties) === propertyKey(original.properties));
    const exact = matches.find(item => item.key === original.key);
    if (exact) return exact;
    if (matches.length > 1) throw new Error('ambiguous_extra');
    return matches[0] || null;
  }
  function planExtraChange(result, snapshot, lineKey, variantId) {
    const known = result.existing.find(item => item.key === lineKey);
    const original = snapshot.items.find(item => item.key === lineKey);
    if (result.included || !known || !original || !same(original.id,known.id) || !same(original.product_id,result.rule.productId) || original.quantity !== known.quantity || !Number.isInteger(original.quantity) || original.quantity < 1 || original.selling_plan_allocation || original.parent_relationship) throw new Error('extra_changed');
    const target = variantId == null ? null : result.variants.find(item => same(item.id,variantId) && item.available);
    if (variantId != null && !target) throw new Error('variant_unavailable');
    return { original: {...original,properties:{...original.properties}}, target, noop: Boolean(target && same(target.id,original.id)) };
  }
  async function changeExtraLine(api, plan, operationId) {
    if (plan.noop) return null;
    const original = plan.original;
    const tagged = snapshot => snapshot.items.filter(item => plan.target && same(item.id,plan.target.id) && item.properties?._sk_extra_swap === operationId);
    let sections = null;
    try {
      if (plan.target) {
        await api.add({id:Number(plan.target.id),quantity:original.quantity,properties:{...original.properties,_sk_extra_swap:operationId}});
        const current = await api.read();
        const replacement = tagged(current);
        if (replacement.length !== 1 || replacement[0].quantity !== original.quantity) throw new Error('replacement_unconfirmed');
        const old = matchingLine(current.items,original);
        if (old && old.quantity !== original.quantity) throw new Error('extra_quantity_changed');
        if (old) sections = (await api.remove(old.key)).sections;
      } else {
        sections = (await api.remove(original.key)).sections;
      }
      const current = await api.read();
      const replacement = tagged(current);
      if (matchingLine(current.items,original) || plan.target && (replacement.length !== 1 || replacement[0].quantity !== original.quantity)) throw new Error('change_unconfirmed');
      return sections;
    } catch (_) {
      // Never retry an add blindly. Verify its unique marker and roll back only that replacement.
      let recovered = false;
      try {
        let current = await api.read();
        let old = matchingLine(current.items,original);
        let replacement = tagged(current);
        if (!old && (!plan.target || replacement.length === 1 && replacement[0].quantity === original.quantity)) return sections;
        if (old?.quantity === original.quantity) {
          for (let attempts = 0; replacement.length && attempts < 10; attempts++) {
            await api.remove(replacement[0].key);
            current = await api.read();
            replacement = tagged(current);
          }
          old = matchingLine(current.items,original);
          recovered = !replacement.length && old?.quantity === original.quantity;
        }
      } catch (_) {}
      const error = new Error(recovered ? 'change_not_applied' : 'change_unconfirmed');
      error.uncertain = !recovered;
      throw error;
    }
  }
  window.SketchusUpsellRules = Object.freeze({ evaluate, sourceEligible, previewIncluded, planExtraChange, matchingLine, changeExtraLine });
  const root = document.getElementById('SketchusNativeUpsell');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  let config;
  try { config = JSON.parse(root.querySelector('[data-config]').textContent); } catch (_) { return; }
  const strings = config.strings;
  const dialog = root.querySelector('dialog');
  const inline = root.querySelector('[data-inline]');
  const sourceSelect = root.querySelector('[data-source]');
  const status = root.querySelector('[data-status]');
  const popupList = root.querySelector('[data-popup-offers]');
  const inlineList = root.querySelector('[data-inline-offers]');
  let cart = config.cart;
  let source = null;
  let busy = false;
  let activeMutation = null;
  let uncertain = false;
  let previousFocus = null;
  let overlayTimer = null;
  let refreshTimer = null;
  const pending = new WeakMap();
  const selections = new Map();
  const selectionKey = rule => (source?.key || '') + ':' + rule.key;
  const extras = () => config.rules.map(rule => rule.productId);
  const token = () => window.crypto?.randomUUID?.() || Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  function emit(name, rule, variantId, state) {
    const placement = ['sk_upsell_view','sk_upsell_reopen','sk_upsell_dismiss','sk_upsell_continue'].includes(name) ? 'popup' : name === 'sk_upsell_eligible' ? 'cart' : dialog.open ? 'popup' : 'inline';
    const detail = { source_product_id: source?.product_id || null, source_variant_id: source?.id || null, source_size: source?.size || null, offer_type: rule?.kind || null, rule_key: rule?.key || null, offer_variant_id: variantId || null, locale: config.locale, market: config.market, country: config.country, placement, release: 'native_extras_v2', state: state || null };
    root.dataset.lastEvent = name;
    root.dispatchEvent(new CustomEvent('sketchus:' + name, { bubbles: true, detail }));
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      window.Shopify?.analytics?.publish?.(name, detail);
      if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name, ...detail });
    } catch (_) {}
  }
  function formSource(form) {
    if (!config.enabled || !form || form.matches('[data-extra]')) return null;
    const id = form.querySelector('[name="id"]')?.value;
    const page = config.pageProduct;
    const productId = config.catalog[id] || (page && has(page.variants,id) ? page.id : null);
    const result = { id, product_id: productId, gift_card: Boolean(page && same(page.id,productId) && page.giftCard) };
    return sourceEligible(result,config) ? result : null;
  }
  function hidden(form, name, value) {
    let input = Array.from(form.elements).find(element => element.name === name);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
    input.value = value;
    input.disabled = false;
  }
  function prepareSource(form) {
    const selected = formSource(form);
    if (!selected) return false;
    let context = pending.get(form);
    if (!context || !same(context.id,selected.id)) { context = { id:selected.id, event:token() }; pending.set(form,context); }
    const destination = new URL(config.cartUrl, window.location.origin);
    destination.searchParams.set('sk_upsell','1');
    destination.searchParams.set('sk_event',context.event);
    destination.searchParams.set('sk_variant',String(selected.id));
    hidden(form,'return_to',destination.pathname + destination.search);
    hidden(form,'properties[_sk_upsell_event]',context.event);
    return true;
  }
  window.SketchusNativeUpsell = Object.freeze({ prepareSource, ownsForm: form => Boolean(formSource(form)) });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.matches('.skv25__form,[data-extra]')) return;
    if (form.action && new URL(form.action,location.origin).pathname.endsWith('/localization')) {
      const input = form.querySelector('[name="return_to"]');
      if (input?.value) {
        const destination = new URL(input.value,location.origin);
        ['sk_event','sk_variant','sk_upsell'].forEach(key => destination.searchParams.delete(key));
        input.value = destination.pathname + destination.search + destination.hash;
      }
      return;
    }
    if (!form.action || new URL(form.action,location.origin).pathname.replace(/\.js$/,'') !== config.addUrl || !prepareSource(form)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.skSubmitting) return;
    form.dataset.skSubmitting = 'true';
    form.enctype = 'multipart/form-data';
    HTMLFormElement.prototype.submit.call(form);
  }, true);
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      close('back');
      document.querySelectorAll('form').forEach(form => { delete form.dataset.skSubmitting; pending.delete(form); });
    }
  });
  if (!document.getElementById('main-cart-items')) return;
  root.hidden = false;
  const cartFooter = document.getElementById('main-cart-footer');
  if (cartFooter) cartFooter.insertAdjacentElement('beforebegin',root);
  const sourceLines = () => cart.items.filter(item => sourceEligible(item,config));
  function chooseSource(key) {
    const lines = sourceLines();
    source = lines.find(item => item.key === key) || lines[0] || null;
    sourceSelect.replaceChildren(...lines.map(item => new Option(item.title + ' · ' + item.variant_title,item.key)));
    if (source) sourceSelect.value = source.key;
    sourceSelect.closest('label').hidden = lines.length < 2;
  }
  function existingVariant(result) {
    const selected = result.variants.find(variant => same(variant.id,selections.get(selectionKey(result.rule))));
    if (selected && (busy || !result.existing.length)) return selected;
    return result.variants.find(variant => result.existing.some(item => same(item.id,variant.id))) || result.variants[0];
  }
  function card(result, placement) {
    const node = root.querySelector('[data-card]').content.firstElementChild.cloneNode(true);
    const rule = result.rule;
    const includedReady = result.included && result.existing.length === 0 && cart.previewEntitlement === 'Vorschau inklusive / Preview included';
    node.dataset.rule = rule.key;
    const label = rule.title || strings[rule.kind + '_title'] || rule.productTitle;
    node.querySelector('h3').textContent = label;
    let description = includedReady ? strings.included_description : rule.description || strings[rule.kind + '_description'] || '';
    if (rule.kind === 'preview' && !includedReady && !rule.description && config.previewThreshold && cart.currency === 'EUR') description += ' ' + strings.preview_free;
    node.querySelector('[data-description]').textContent = description;
    const img = node.querySelector('img');
    const form = node.querySelector('form');
    const select = form.querySelector('select');
    node.querySelector('[data-select-label]').textContent = rule.kind === 'frame' ? strings.color : strings.variant;
    const selected = existingVariant(result);
    result.variants.forEach(variant => {
      let title = variant.title;
      if (rule.kind === 'frame' && strings[variant.color]) title = source.size + ' / ' + strings[variant.color];
      if (rule.kind === 'express' && same(variant.id,53121456636168)) title = strings.seven_days;
      if (rule.kind === 'express' && same(variant.id,53121456668936)) title = strings.fourteen_days;
      select.add(new Option(title,String(variant.id),false,same(variant.id,selected.id)));
    });
    node.querySelector('.sk-native__variant').hidden = result.variants.length === 1;
    const button = node.querySelector('[data-add]');
    const existing = result.existing.find(item => same(item.id,selected.id)) || result.existing[0];
    const updateVariant = () => {
      const variant = result.variants.find(item => same(item.id,select.value));
      if (!variant) { button.disabled = true; return; }
      const image = variant.image || rule.image;
      img.hidden = !image;
      if (image) img.src = image;
      img.alt = label + (rule.kind === 'frame' ? ' · ' + source.size + ' · ' + (strings[variant.color] || variant.title) : '');
      node.querySelector('[data-price]').textContent = result.included ? includedReady ? strings.included : strings.checking : variant.money;
      const compare = node.querySelector('[data-compare]');
      compare.hidden = result.included || !(variant.compare > variant.price);
      compare.textContent = compare.hidden ? '' : variant.compareMoney;
    };
    updateVariant();
    select.addEventListener('change',() => {
      selections.set(selectionKey(rule),select.value);
      updateVariant();
      if (existing && !same(existing.id,select.value)) mutateExtra(result,existing.key,select.value,placement);
    });
    const added = Boolean(existing && !result.included);
    const active = busy && activeMutation?.ruleKey === rule.key;
    node.dataset.added = String(added);
    node.dataset.waiting = String(busy && !active);
    node.setAttribute('aria-busy',String(active));
    node.querySelector('[data-tick]').hidden = !added;
    button.textContent = result.included ? includedReady ? strings.included : strings.checking : active ? activeMutation.action === 'add' ? strings.adding : strings.updating : added ? strings.added : strings.add;
    button.disabled = result.locked || busy || uncertain;
    select.disabled = result.included || busy || uncertain;
    const remove = node.querySelector('[data-remove]');
    remove.hidden = !added;
    remove.disabled = busy || uncertain;
    remove.setAttribute('aria-label',strings.remove + ': ' + label);
    remove.addEventListener('click',() => mutateExtra(result,existing.key,null,placement));
    form.addEventListener('submit', event => addExtra(event,result,select.value,placement));
    if (result.variants.length > 1 && ['frame','express'].includes(rule.kind)) {
      const choices = document.createElement('div');
      choices.className = 'sk-native__choices';
      choices.setAttribute('role','group');
      choices.setAttribute('aria-label',node.querySelector('[data-select-label]').textContent);
      const syncChoices = () => {
        choices.querySelectorAll('button').forEach(choice => {
          choice.setAttribute('aria-pressed',String(choice.dataset.variant === select.value));
          choice.disabled = select.disabled;
        });
      };
      Array.from(select.options).forEach(option => {
        const choice = document.createElement('button');
        choice.type = 'button';
        choice.className = 'sk-native__choice';
        choice.dataset.variant = option.value;
        choice.textContent = option.textContent.replace(' / ',' ');
        choice.addEventListener('click',() => {
          if (select.disabled || select.value === option.value) return;
          select.value = option.value;
          select.dispatchEvent(new Event('change',{bubbles:true}));
          syncChoices();
        });
        choices.append(choice);
      });
      select.addEventListener('change',syncChoices);
      node.querySelector('.sk-native__variant').hidden = true;
      form.classList.add('sk-native__button-row');
      form.insertBefore(choices,node.querySelector('.sk-native__actions'));
      syncChoices();
    }
    return node;
  }
  function render() {
    const inlineResults = source ? evaluate(source,cart,config,'inline') : [];
    const popupResults = source ? evaluate(source,cart,config,'popup') : [];
    inline.hidden = !config.inline || !inlineResults.length;
    inlineList.replaceChildren(...inlineResults.map(result => card(result,'inline')));
    popupList.replaceChildren(...popupResults.map(result => card(result,'popup')));
    root.querySelector('[data-reopen]').hidden = !config.popup || !popupResults.length;
    if (!popupResults.length && dialog.open) close('no_offers');
    if (config.debug) root.dataset.diagnostics = config.rules.filter(rule => !inlineResults.some(result => result.rule.key === rule.key)).map(rule => rule.key).join(',');
  }
  function otherOverlay() {
    if (document.body.matches('.sketchus-chat-open,.sk-email-popup-open,.sk-v14-overlay-open,.sk-v15-external-overlay-open')) return true;
    return [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(element => {
      const style = getComputedStyle(element);
      return element !== dialog && element.getAttribute('aria-hidden') !== 'true' && !element.closest('details:not([open])') && element.getClientRects().length && style.visibility !== 'hidden' && style.opacity !== '0';
    });
  }
  function open(manual) {
    if (!config.popup || !source || !evaluate(source,cart,config,'popup').length || otherOverlay() || typeof dialog.showModal !== 'function') return false;
    previousFocus = document.activeElement;
    clearTimeout(overlayTimer);
    document.body.classList.add('sk-native-overlay');
    document.documentElement.classList.add('sk-native-lock');
    document.dispatchEvent(new CustomEvent('sketchus:overlay-priority'));
    try { dialog.showModal(); } catch (_) { release(); return false; }
    root.querySelector('[data-close]').focus({preventScroll:true});
    emit(manual ? 'sk_upsell_reopen' : 'sk_upsell_view');
    return true;
  }
  function release() {
    document.documentElement.classList.remove('sk-native-lock');
    clearTimeout(overlayTimer);
    overlayTimer = setTimeout(() => { if (!dialog.open) document.body.classList.remove('sk-native-overlay'); }, 2500);
  }
  function close(reason) {
    if (dialog.open) { dialog.close(); emit(reason === 'continue' ? 'sk_upsell_continue' : 'sk_upsell_dismiss',null,null,reason); }
    release();
    const target = previousFocus?.isConnected && previousFocus !== document.body ? previousFocus : document.getElementById('checkout');
    target?.focus({preventScroll:true});
  }
  dialog.addEventListener('cancel', event => { event.preventDefault(); close('escape'); });
  dialog.addEventListener('close',release);
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close('backdrop'); } });
  root.querySelector('[data-close]').addEventListener('click',() => close('close'));
  root.querySelector('[data-continue]').addEventListener('click',() => close('continue'));
  root.querySelector('[data-reopen]').addEventListener('click',() => open(true));
  root.addEventListener('click', event => { if (event.target.closest('[data-check-cart]')) close('check_cart'); });
  inline.addEventListener('click', event => { if (event.target.closest('[data-check-cart]')) close('check_cart'); });
  sourceSelect.addEventListener('change',() => { chooseSource(sourceSelect.value); render(); });
  async function fetchConfig() {
    const url = new URL(config.cartUrl,location.origin);
    url.searchParams.set('section_id',root.dataset.sectionId);
    const response = await fetch(url,{credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('cart_unavailable');
    const html = await response.text();
    const data = new DOMParser().parseFromString(html,'text/html').querySelector('#SketchusNativeUpsell [data-config]');
    if (!data) throw new Error('config_unavailable');
    const next = JSON.parse(data.textContent);
    if (!next.cart || !Array.isArray(next.cart.items)) throw new Error('cart_invalid');
    config = next; cart = next.cart;
    chooseSource(source?.key); return next;
  }
  async function syncPreviewEntitlement() {
    const included = previewIncluded(cart,config);
    const previewProducts = config.rules.filter(rule => rule.kind === 'preview').map(rule => rule.productId);
    let sections = null;
    if (included) {
      const paidLines = cart.items.filter(item => has(previewProducts,item.product_id));
      for (const item of paidLines) {
        const response = await fetch(config.changeUrl + '.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0,sections:sectionTargets().map(target => target.section),sections_url:config.cartUrl})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error('preview_fee_not_removed');
        sections = data.sections;
      }
    }
    const marker = included ? 'Vorschau inklusive / Preview included' : '';
    if ((cart.previewEntitlement || '') !== marker) {
      const response = await fetch(config.updateUrl + '.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Sketchus Preview':marker}})});
      if (!response.ok) throw new Error('preview_marker_not_saved');
    }
    await fetchConfig();
    return sections;
  }
  function sectionTargets() {
    return [{id:'main-cart-items',selector:'.js-contents'}, {id:'main-cart-footer',selector:'.js-contents'}, {id:'cart-icon-bubble',selector:'.shopify-section'}].map(target => ({...target,section:document.getElementById(target.id)?.dataset.id || target.id}));
  }
  function reconcile(sections) {
    let complete = true;
    sectionTargets().forEach(target => {
      const current = document.getElementById(target.id);
      if (!current) return;
      const markup = sections?.[target.section];
      const next = typeof markup === 'string' ? new DOMParser().parseFromString(markup,'text/html').querySelector(target.selector) : null;
      if (!next) { complete = false; return; }
      const destination = current.querySelector(target.selector) || current;
      destination.innerHTML = next.innerHTML;
    });
    const cartItems = document.querySelector('cart-items');
    if (cartItems) cartItems.currentItemCount = cart.item_count;
    return complete;
  }
  function showFailure(message) {
    status.textContent = message;
    [...popupList.querySelectorAll('[data-message]'),...inlineList.querySelectorAll('[data-message]')].forEach(element => { element.hidden = false; element.textContent = message; });
    [...popupList.querySelectorAll('[data-check-cart]'),...inlineList.querySelectorAll('[data-check-cart]')].forEach(element => { element.hidden = false; });
  }
  async function mutateExtra(previous, lineKey, variantId, placement) {
    if (busy || uncertain || previous.included) return;
    const sourceKey = source?.key;
    const sourceVariant = source?.id;
    const checkout = document.getElementById('checkout');
    const checkoutDisabled = checkout?.disabled;
    const continueButton = root.querySelector('[data-continue]');
    const action = variantId == null ? 'remove' : 'change';
    let attempted = false;
    activeMutation = {ruleKey:previous.rule.key,action};
    busy = true; render(); status.textContent = strings.updating;
    if (checkout) checkout.disabled = true;
    continueButton.disabled = true;
    const read = async () => {
      const response = await fetch(config.cartUrl + '.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('cart_unavailable');
      const data = await response.json();
      if (!Array.isArray(data.items)) throw new Error('cart_invalid');
      return data;
    };
    const post = async (url, payload) => {
      const response = await fetch(url + '.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:sectionTargets().map(target => target.section),sections_url:config.cartUrl})});
      const data = await response.json();
      if (!response.ok || data.status) throw new Error('cart_change_rejected');
      return data;
    };
    try {
      await fetchConfig();
      source = cart.items.find(item => item.key === sourceKey && same(item.id,sourceVariant));
      const result = source && evaluate(source,cart,config,placement).find(item => item.rule.key === previous.rule.key);
      if (!result) throw new Error('offer_changed');
      const snapshot = await read();
      if (!snapshot.items.some(item => item.key === sourceKey && same(item.id,sourceVariant))) throw new Error('source_changed');
      const plan = planExtraChange(result,snapshot,lineKey,variantId);
      if (plan.noop) { busy = false; render(); return; }
      emit('sk_upsell_' + action + '_start',result.rule,variantId || plan.original.id);
      attempted = true;
      const sections = await changeExtraLine({read,add:item => post(config.addUrl,{items:[item]}),remove:key => post(config.changeUrl,{id:key,quantity:0})},plan,token());
      await fetchConfig();
      const previewSections = await syncPreviewEntitlement();
      busy = false; render();
      status.textContent = variantId == null ? strings.removed : strings.updated;
      emit('sk_upsell_' + action + '_success',result.rule,variantId || plan.original.id);
      if (!reconcile(previewSections || sections)) { close('cart_refresh'); location.assign(config.cartUrl); return; }
      const container = dialog.open ? popupList : inlineList;
      const changed = [...container.querySelectorAll('[data-rule]')].find(item => item.dataset.rule === result.rule.key);
      (changed?.querySelector(variantId == null ? '[data-add]' : '.sk-native__choice[aria-pressed="true"], select') || root.querySelector('[data-continue]'))?.focus({preventScroll:true});
    } catch (error) {
      try { await fetchConfig(); } catch (_) {}
      busy = false;
      uncertain = attempted && error.uncertain !== false;
      render(); showFailure(uncertain ? strings.uncertain : strings.update_error);
      emit('sk_upsell_' + action + '_error',previous.rule,variantId,uncertain ? 'unconfirmed' : 'not_changed');
      if (uncertain) { close('cart_refresh'); location.assign(config.cartUrl); return; }
    } finally {
      activeMutation = null;
      const currentCheckout = document.getElementById('checkout');
      if (currentCheckout && checkoutDisabled !== undefined) currentCheckout.disabled = checkoutDisabled;
      continueButton.disabled = false;
    }
  }
  async function addExtra(event, previous, variantId, placement) {
    if (busy || uncertain || previous.locked) { event.preventDefault(); return; }
    if (typeof fetch !== 'function') return;
    event.preventDefault();
    const sourceKey = source?.key;
    const sourceVariant = source?.id;
    const ruleKey = previous.rule.key;
    const focusedVariant = variantId;
    activeMutation = {ruleKey,action:'add'};
    busy = true; render();
    let attempted = false;
    try {
      await fetchConfig();
      source = cart.items.find(item => item.key === sourceKey && same(item.id,sourceVariant));
      const result = source && evaluate(source,cart,config,placement).find(item => item.rule.key === ruleKey);
      if (!result || result.locked || !result.variants.some(item => same(item.id,focusedVariant))) { busy = false; chooseSource(sourceKey); render(); return; }
      emit('sk_upsell_add_start',result.rule,focusedVariant);
      attempted = true;
      const response = await fetch(config.addUrl + '.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(focusedVariant),quantity:1}],sections:sectionTargets().map(target => target.section),sections_url:config.cartUrl})});
      const data = await response.json();
      if (!response.ok || data.status) { attempted = false; throw new Error('add_rejected'); }
      await fetchConfig();
      const added = cart.items.some(item => same(item.id,focusedVariant));
      if (!added) throw new Error('add_unconfirmed');
      const previewSections = await syncPreviewEntitlement();
      emit('sk_upsell_add_success',result.rule,focusedVariant);
      busy = false; render(); status.textContent = strings.added;
      if (!reconcile(previewSections || data.sections)) { close('cart_refresh'); location.assign(config.cartUrl); return; }
      const focusContainer = dialog.open ? popupList : inlineList;
      const nextButton = focusContainer.querySelector('[data-add]:not(:disabled)') || (dialog.open ? root.querySelector('[data-continue]') : inline.querySelector('summary'));
      nextButton?.focus({preventScroll:true});
    } catch (_) {
      let confirmed = false;
      try { await fetchConfig(); confirmed = attempted && cart.items.some(item => same(item.id,focusedVariant)); } catch (_) {}
      busy = false;
      if (confirmed) { emit('sk_upsell_add_success',previous.rule,focusedVariant,'recovered'); close('cart_refresh'); location.assign(config.cartUrl); return; }
      uncertain = attempted;
      emit('sk_upsell_add_error',previous.rule,focusedVariant,attempted ? 'unconfirmed' : 'not_added');
      render(); showFailure(attempted ? strings.uncertain : strings.error);
    } finally {
      activeMutation = null;
    }
  }
  const url = new URL(location.href);
  const eventToken = url.searchParams.get('sk_event');
  const variantId = url.searchParams.get('sk_variant');
  const requested = url.searchParams.get('sk_upsell') === '1';
  const matches = requested && eventToken && variantId ? cart.items.filter(item => item.event === eventToken && same(item.id,variantId) && sourceEligible(item,config)) : [];
  let consumed = false;
  if (eventToken) {
    try { consumed = sessionStorage.getItem('sk-native-last-event') === eventToken; sessionStorage.setItem('sk-native-last-event',eventToken); } catch (_) {}
  }
  ['sk_event','sk_variant','sk_upsell'].forEach(key => url.searchParams.delete(key));
  if (requested || eventToken) { try { history.replaceState(history.state,'',url.pathname + url.search + url.hash); } catch (_) { consumed = true; } }
  chooseSource(matches.length === 1 ? matches[0].key : null);
  render();
  async function refreshCartBenefits() {
    if (busy || uncertain || typeof fetch !== 'function') return;
    busy = true;
    try { await fetchConfig(); const sections = await syncPreviewEntitlement(); busy = false; render(); if (sections && !reconcile(sections)) location.assign(config.cartUrl); }
    catch (_) { busy = false; render(); showFailure(strings.uncertain); }
  }
  if (previewIncluded(cart,config) || cart.previewEntitlement) refreshCartBenefits();
  if (!consumed && matches.length === 1) {
    emit('sk_upsell_eligible');
    if (!open(false) && config.overlay === 'wait') {
      const started = Date.now();
      const wait = setInterval(() => { if (Date.now() - started > 8000 || open(false)) clearInterval(wait); }, 400);
      window.addEventListener('pagehide',() => clearInterval(wait),{once:true});
    }
  }
  const cartContent = document.querySelector('#main-cart-items .js-contents');
  if (cartContent) new MutationObserver(() => {
    if (busy || uncertain) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartBenefits,350);
  }).observe(cartContent,{childList:true});
  window.addEventListener('pagehide',() => { clearTimeout(overlayTimer); clearTimeout(refreshTimer); document.documentElement.classList.remove('sk-native-lock'); document.body.classList.remove('sk-native-overlay'); });
})();
  } catch(e) { console.error(e); }
})();

})();
